import { FormulaCommand } from "./FormulaCommand";
import { FormulaLexem } from "./lexem/FormulaLexem";
import { parseLexems } from "./lexem/parseLexems";
import { FormulaOperation } from "./operation/FormulaOperation";
import { operationPriority } from "./operation/OperationPriority";

/* eslint no-plusplus: "off" */

/**
 * Транслировать текстовую формулу в набор исполняемых команд
 * @throws В случае ошибки генерируется исключение
 */
export const translateFormula = (text: string): FormulaCommand[] => {
  const lexems = parseLexems(text);
  return expression(lexems, 0).cmdList;
};

type ExprRes = {
  pos: number;
  cmdList: FormulaCommand[];
};
type OpInfo = {
  code: FormulaOperation;
  prior: number;
};

const expression = (
  lexems: FormulaLexem[],
  startPos: number,
  stopper?: string,
): ExprRes => {
  let pos = startPos;
  let cmdList: FormulaCommand[] = [];
  const opStack: OpInfo[] = [];

  const isStop = (): boolean => lexems[pos]?.text === stopper;

  const nextLexem = (): FormulaLexem => {
    const lexem = lexems[pos++];
    if (!lexem) throw Error("Нарушен список лексем");
    return lexem;
  };

  const unwindOperations = (prior: number) => {
    for (;;) {
      const op = opStack.shift();
      if (!op) break;
      if (prior > op.prior) {
        opStack.unshift(op);
        break;
      } else {
        cmdList.push({ type: "op", code: op.code });
      }
    }
  };

  const addArgument = (cmd: FormulaCommand) => {
    cmdList.push(cmd);
    if (!isStop()) middle();
  };
  const addOperation = (code: FormulaOperation, prior: number) => {
    unwindOperations(prior);
    opStack.unshift({ code, prior });
  };

  const wrongLexem = (lexem: FormulaLexem) => {
    throw Error(
      `Недопустимая лексема "${lexem.text}" в позиции ${lexem.pos + 1}`,
    );
  };

  const start = () => {
    const lexem = nextLexem();
    if (lexem.type === "number") {
      addArgument({ type: "number", value: +lexem.text });
    } else if (lexem.type === "uid") {
      addArgument({ type: "attr", uid: lexem.text });
    } else if (lexem.text === "(") {
      const res = expression(lexems, pos, ")");
      cmdList = [...cmdList, ...res.cmdList];
      pos = res.pos;
      if (!isStop()) middle();
    } else if (lexem.text === "-") {
      addOperation("~", operationPriority["~"]);
    } else {
      wrongLexem(lexem);
    }
  };

  const middle = () => {
    const lexem = nextLexem();
    if (lexem.type === "symbol") {
      const opCode = lexem.text as FormulaOperation;
      const prior = operationPriority[opCode];
      if (typeof prior === "number") {
        addOperation(opCode, prior);
        return;
      }
    }
    wrongLexem(lexem);
  };

  while (!isStop()) {
    start();
  }
  unwindOperations(0);
  return { cmdList, pos: pos + 1 };
};
